export const OrganizationnalUnitCodeHeaderName = 'QC-OUCode';
